import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card-body p-xl-40" }
const _hoisted_2 = { class: "card-title fw-semiBold fs-18 mb-30" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center",
  style: {"height":"300px"}
}
const _hoisted_4 = {
  key: 1,
  class: "chart-body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h6", _hoisted_2, _toDisplayString(_ctx.$t("dashboard_page.top_customers", { month: _ctx.currentMonth })), 1),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("loading")), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_apexchart, {
            type: "donut",
            width: "90%",
            options: _ctx.topCustomerChart,
            series: _ctx.customer
          }, null, 8, ["options", "series"])
        ]))
  ]))
}